import React from 'react';
import { withRouter, Link } from 'react-router-dom';

import ContentLayout from 'component/page/content';
import API, {handleError} from 'utils/xhr';
import { PlayerJS } from 'component/reuse/js_code';
import {InstructionsPara} from 'component/reuse/instruction';
import Track from 'utils/tracker';


class ShowDetail extends React.Component {
  state = {
    show: null,
    show_name: '',
  }

  onChange(e){
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }
  
  handleUpdate(){
    const show_xid = this.props.show.xid;
    const url = '/shows/' + show_xid;
    const data = {
      show_name: this.state.show_name,
    }
    API.post(url, data).then(response =>{
      const show = response.data.data;
      const state = this.state;
      state.show = show;
      state.show_name = show.show_name || '';
      this.setState(state);

      Track.show("Updated", show_xid);
    },(error) =>{
      Track.show("Update failed", show_xid);
      handleError(error, this.props.history, window.location.pathname);
    })

  }

  handleDelete(){
    const show_xid = this.props.show.xid;
    const url = '/shows/' + show_xid;
    API.delete(url).then(response =>{
      Track.show("Deleted", show_xid);
      // TODO: fix me .. wrong
      window.location.href = '/';
    },(error) =>{
      Track.show("Delete failed", show_xid);
      handleError(error, this.props.history, window.location.pathname);
    }, this)

  }

  render(){
    const show = this.state.show || this.props.show;

    if (show === null){ return ('')}

    const show_name = show.show_name || this.state.show_name;

    return (
      <div className="">
        <Link to={"/shows/" + show.xid}><h3><strong>{(show.show_name)? show.show_name: show.xid}</strong></h3></Link>
        <div className="my-2">
          <PlayerJS show_xid={show.xid}/>

          <div className="d-flex justify-content-between">
            <InstructionsPara short={true}/>
            <span className="m-0 my-lg-0">
              <div className="my-1"><small>Show created on: <b>{new Date(show.inserted_at).toLocaleString()}</b></small></div>
            </span>
          </div>

          <hr className="my-3"/>

          <div className="form-group row">
            <label className="col-sm-2 col-form-label">Show ID:</label>
            <div className="col-sm-10"><label className="form-control-plaintext">{show.xid}</label></div>
          </div>

          <div className="form-group">
            <label className="text-muted">Give your show a name</label>
            <input className="form-control" name="show_name" placeholder="Landing page | Account creation | City filter instruction | Analytics overview show" onChange={this.onChange.bind(this)} value={show_name} />
            <small className="form-text text-muted">To easily remember what the show was about.</small>
          </div>

          <button className="btn btn-success m-2" onClick={this.handleUpdate.bind(this)}><i className="fa fa-save mr-2"></i>Update</button>
          <button className="btn btn-danger m-2" onClick={this.handleDelete.bind(this)}><i className="fa fa-trash mr-2"></i>Delete</button>


        </div>
      </div>
    )
  }
}


class Page extends React.Component {
  constructor(props){
    super(props);
    const {show_xid} = props.match.params;
    this.state = {
      show_xid: show_xid || null,
      show_details: null,
      fetching_data: {
        list_sites: false,
      },
    }
  }

  componentDidMount(){
    const url = '/shows/' + this.state.show_xid + '?min=true';
    API.get(url).then(response =>{
      const state = this.state;
      state.show_details = response.data.data;
      this.setState(state);
    },(error) =>{
      handleError(error, this.props.history);
    })
  }

  render (){
    return (
      <ContentLayout id="detail-show-page">
        <div className="container">
          <ShowDetail show={this.state.show_details}/>
        </div>
      </ContentLayout>
    )
  }
}


export default withRouter(Page);